var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGadgetNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 150,
    viewBox: "0 0 216 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.926 17.5684H78.8922C76.5195 17.5684 74.5967 19.4016 74.5967 21.663V129.237C74.5967 131.499 76.5195 133.332 78.8922 133.332H136.926C139.299 133.332 141.222 131.499 141.222 129.237V21.663C141.222 19.4016 139.299 17.5684 136.926 17.5684Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 23,
    width: 58,
    height: 108,
    rx: 4,
    fill: "#FCF2EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.926 133.901H78.8922C76.1949 133.901 74 131.81 74 129.238V21.6634C74 19.0914 76.1949 17 78.8922 17H136.926C139.623 17 141.818 19.0914 141.818 21.6634V129.238C141.818 131.81 139.623 133.901 136.926 133.901ZM78.8922 18.1392C76.8534 18.1392 75.1948 19.7205 75.1948 21.6634V129.238C75.1948 131.181 76.8534 132.762 78.8922 132.762H136.926C138.965 132.762 140.624 131.181 140.624 129.238V21.6634C140.624 19.7205 138.965 18.1392 136.926 18.1392H78.8922Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.91 26.2911C106.979 26.2911 106.225 25.5723 106.225 24.6851C106.225 23.7979 106.979 23.0791 107.91 23.0791C108.84 23.0791 109.595 23.7979 109.595 24.6851C109.595 25.5723 108.84 26.2911 107.91 26.2911Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadgetNewIcon);
export default __webpack_public_path__ + "static/media/gadget-new-icon.bd63009f6ddec353400eeef3e6b6a87c.svg";
export { ForwardRef as ReactComponent };